var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaveSegment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03823 0.139648H0V10.0017H1.03823V0.139648Z",
    fill: "#EA5454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9622 1.03613H12.924V10.0024H13.9622V1.03613Z",
    fill: "#EA5454"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68529 8.97461H0.519043V10.0019H5.68529V8.97461Z",
    fill: "#EA5454"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9622 8.97461H8.7959V10.0019H13.9622V8.97461Z",
    fill: "#EA5454"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9621 1.03613V2.06343H5.66038L4.75504 1.16763H1.03816V2.06343H0.519043V1.03613H13.9621Z",
    fill: "#EA5454"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27917 1.16694H0.519043V0.139648H5.24093L6.15042 1.03545L6.16288 1.05189L6.27917 1.16694Z",
    fill: "#EA5454"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18877 2.06274H5.66049L4.75515 1.16694L4.32739 0.743698L4.94203 0.139648H5.24104L6.15053 1.03545L6.16299 1.05189L6.27927 1.16694L7.18877 2.06274Z",
    fill: "#EA5454"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65384 5.94141H6.6156V11.7641H7.65384V5.94141Z",
    fill: "#EA5454"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65384 8.50586H6.6156V9.53315H7.65384V8.50586Z",
    fill: "#EA5454"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18866 13.4365L5.94693 12.2325L4.7052 11.0244H7.18866H9.66796L8.42623 12.2325L7.18866 13.4365Z",
    fill: "#EA5454"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveSegment);
export default __webpack_public_path__ + "static/media/save-segment.ecdace163f71ed29ea84fc197a829b7a.svg";
export { ForwardRef as ReactComponent };